import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './ModernCarousel.css';

const ModernCarousel = ({ items, className = "" }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={`modern-carousel ${className}`}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        spaceBetween={30}
        slidesPerView={1}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        effect="fade"
        fadeEffect={{
          crossFade: true,
        }}
        loop={items.length > 1}
        className="modern-swiper"
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="carousel-slide">
              <img
                src={item.src}
                alt={item.altText || `Slide ${index + 1}`}
                className="carousel-image"
                loading="lazy"
              />
              {(item.caption || item.header) && (
                <div className="carousel-caption">
                  <h4 className="carousel-title">{item.header || item.caption}</h4>
                  {item.caption && item.header && item.caption !== item.header && (
                    <p className="carousel-description">{item.caption}</p>
                  )}
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      
      {/* Custom Navigation Buttons */}
      <div className="swiper-button-prev">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="swiper-button-next">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  );
};

export default ModernCarousel;
